import { showErrorStrToast, showToast } from "../../../../features/ui"
import { TableName } from "../../../../tables"
import { capitalize } from "../../../../utils/typeUtils"
import { useHoardService } from "../../../sales"
import { operationHelpers } from "../../hooks/operationHooks"
import { Operation } from "../../state/types"

export const useActions = () => {
    const { describeCode } = operationHelpers

    const { closeHoard } = useHoardService()

    const getOperationLabel = (
        table: TableName,
        operation: Operation
    ): string => {
        const prefix = new Map<TableName, string>()
            .set(TableName.PURCHASE_ORDERS, 'la Compra')
            .set(TableName.SALE_ORDERS, 'la Venta')
            .set(TableName.HOARD_ORDERS, 'el Acopio')
        return `${prefix.get(table)!} ${describeCode(operation)}`
    }

    const closeOperation = async (
        table: TableName,
        operation: Operation
    ) => {
        const closedLabel = new Map<TableName, string>()
            .set(TableName.PURCHASE_ORDERS, 'cerrada')
            .set(TableName.SALE_ORDERS, 'cerrada')
            .set(TableName.HOARD_ORDERS, 'cerrado')

        if (table == TableName.HOARD_ORDERS) {
            try {
                await closeHoard(operation.id)
                showToast(`${capitalize(getOperationLabel(table, operation))} fue ${closedLabel.get(table)}.`)
            } catch (error) {
                showErrorStrToast(error instanceof Error ? error.message : 'No se pudo cerrar el acopio.')
            }
        }
    }

    return {
        getOperationLabel,
        closeOperation
    }
}
